const Title = () => (
  <div className="flex justify-center items-center min-h-full">
    <div>
      <h1 className="text-center text-xl">Poesía de Realidad</h1>
      <h2 className="text-center">Jorge Gutiérrez Torres</h2>
    </div>
  </div>
);

export default Title;
